// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButton_buttonStyle__6tLC9","buttonStyleOutlined":"CustomButton_buttonStyleOutlined__10boO"};